import { RootState } from "store/store";
import { EstadoRequisicao } from "store/types";

class ListaSelector {
  static readonly isOcioso = (it: RootState) => it.classificacoes.estado === EstadoRequisicao.OCIOSO;
  static readonly isCarregando = (it: RootState) => it.classificacoes.estado === EstadoRequisicao.CARREGANDO;
  static readonly erros = (it: RootState) => it.classificacoes.erros;

  static readonly elementos = (it: RootState) => it.classificacoes.elementos;
}

export class ClassificacaoSelector {
  static readonly lista = ListaSelector;
}